import { arrayBufferToBase64 } from './base64Helpers';

const JPEG_HEADER = Uint8Array.from([
  0xff, 0xd8, 0xff, 0xe0, 0x00, 0x10, 0x4a, 0x46, 0x49, 0x46, 0x00, 0x01
]);
const JPEG_FOOTER = Uint8Array.from([0xff, 0xd9]);

/**
 * Gera um payload JPEG simples apenas para testes (não representa uma foto real).
 * Produz um arquivo pequeno com cabeçalho/rodapé válidos e dados artificiais.
 */
export const generateTestJpegBytes = (size = 512): Uint8Array<ArrayBuffer> => {
  const minimumSize = JPEG_HEADER.length + JPEG_FOOTER.length + 16;
  const total = Math.max(size, minimumSize);
  const buffer = new Uint8Array(total);
  buffer.set(JPEG_HEADER, 0);

  for (let i = JPEG_HEADER.length; i < total - JPEG_FOOTER.length; i++) {
    buffer[i] = (i * 37) % 256;
  }

  buffer.set(JPEG_FOOTER, total - JPEG_FOOTER.length);
  return buffer;
};

/**
 * Retorna o arquivo de teste em formato base64, pronto para ser gravado no FileSystem/Dexie.
 */
export const generateTestJpegBase64 = (size = 512): string => {
  const bytes = generateTestJpegBytes(size);
  return arrayBufferToBase64(bytes.buffer);
};
